module.exports = __webpack_public_path__ + "img/hunt_rule_bg.2a9f3ead.png";